import { Component, Input } from '@angular/core';

export type AppPlatform = 'ios' | 'android' | 'other';

/** Store links — same URLs as the success page in Docuty.Registration. */
export const APP_STORE_URL = 'https://apps.apple.com/de/app/docuty/id6752243668';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=de.docuty.docutyapp';

export function detectAppPlatform(nav: Pick<Navigator, 'userAgent' | 'maxTouchPoints'> = navigator): AppPlatform {
  const ua = nav.userAgent || '';
  if (/android/i.test(ua)) return 'android';
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
  // iPadOS reports itself as desktop Safari; touch support gives it away.
  if (/macintosh/i.test(ua) && (nav.maxTouchPoints ?? 0) > 1) return 'ios';
  return 'other';
}

/**
 * DOCU-1161: points FREE users to the app, where documentation is captured.
 * On a phone only the matching store is offered, otherwise both.
 */
@Component({
  selector: 'app-get-app',
  templateUrl: './get-app.component.html',
  styleUrl: './get-app.component.scss'
})
export class GetAppComponent {
  /** 'card' renders the bordered page card, 'plain' the bare content (e.g. inside a dialog). */
  @Input() variant: 'card' | 'plain' = 'card';

  readonly platform: AppPlatform = detectAppPlatform();
  readonly appStoreUrl = APP_STORE_URL;
  readonly playStoreUrl = PLAY_STORE_URL;
}
